import { values } from '@/enums/enums'

const _enum = {
  None: 0,
  Calc: 1,
  Sum: 2,
  Avg: 3,
  Max: 4,
  Min: 5,
  AvgNotNull: 7
}

export const aggregationType = {
  enumName: 'AggregationType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/aggregationType.js